export default __webpack_public_path__ + "static/media/onTheSpotPrecheck.4bbeffa4.png";